var alertMixin = {
    methods: {
        alertWithMessage: function (title, message) {
            this.$modal.show('dialog', {
                title: "" + title,
                text: "" + message,
                buttons: [
                    {
                        title: 'OK',
                    },
                ],
            });
        },
        customAlert: function (title, message) {
            var buttons = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                buttons[_i - 2] = arguments[_i];
            }
            this.$modal.show('dialog', {
                title: "" + title,
                text: "" + message,
                buttons: buttons.slice(),
            });
        }
    },
};
export default alertMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/alertMixin.ts
// module id = 06Zu
// module chunks = 18